export enum ProductCategory {
  MEETING_ROOM = "meeting_room",
  EVENT_SPACE = "event_space",
  PRIVATE_OFFICE = "private_office",
  ALL = "all",
}

export enum ProductCategoryLabel {
  MEETING_ROOM = "Meeting rooms",
  EVENT_SPACE = "Event spaces",
  PRIVATE_OFFICE = "Daily offices",
}

export interface ProductCategoryOption {
  label: string;
  value: ProductCategory;
  data?: any;
}

export const productCategoryOptions: ProductCategoryOption[] = [
  {
    label: ProductCategoryLabel.MEETING_ROOM,
    value: ProductCategory.MEETING_ROOM,
  },
  {
    label: ProductCategoryLabel.EVENT_SPACE,
    value: ProductCategory.EVENT_SPACE,
  },
  {
    label: ProductCategoryLabel.PRIVATE_OFFICE,
    value: ProductCategory.PRIVATE_OFFICE,
  },
];
